module.exports = __webpack_public_path__ + "static/media/T8-01.b090bd19.svg";